const NAME = 'userAgentBlacklist';

export default {
  NAME
};
